import React, { useMemo } from 'react';
import { X } from 'lucide-react';
import * as S from './styles';

export interface TagProps {
  className?: string;
  nowrap?: boolean;
  color: 'blue' | 'dark' | 'gray' | 'green' | 'orange' | 'red' | 'yellow' | 'purple';
  children: React.ReactNode | string | number | React.ReactElement[];
  onClick?: () => void;
  onClose?: () => void;
}

const Tag: React.FC<TagProps> = ({ children, className, color, nowrap, onClick, onClose }) => {
  const iconColor = useMemo(() => {
    switch (color) {
      case 'blue':
        return '#0f8594';
      case 'dark':
        return 'rgba(0, 62, 71, 0.8)';
      case 'gray':
        return '#003e47';
      case 'green':
        return '#569720';
      case 'orange':
        return '#f17f16';
      case 'red':
        return '#ff5454';
      case 'yellow':
        return '#dfa800';
      case 'purple':
        return '#6167f5';
      default:
        return 'inherit';
    }
  }, [color]);

  return (
    <S.TagRoot
      onClick={onClick}
      className={className}
      colorType={color}
      isNowrap={nowrap}
      isClickable={!!onClick}
      isClosable={!!onClose}
    >
      {children}
      {!!onClose && (
        <X
          size={16}
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            onClose();
          }}
          color={iconColor}
        />
      )}
    </S.TagRoot>
  );
};

export default Tag;
